import { Col, FormField, FormSelect } from "elemental-react16"
import React, { Component } from "react"
import Pagination from "components/Pagination/Pagination"
import "components/Filter/Filter.scss"
import { Grid, Form, Button, Dropdown } from "semantic-ui-react"

let sortOptions = [
  {
    key:    "Artikel-Nr.",
    text:   translate( "Artikel Nr. A-Z" ),
    value:  "sort",
    params: { sort: "sort", dir: "asc" }
  },
  {
    key:    "Preis",
    text:   translate( "Preis aufsteigend" ),
    value:  "price",
    params: { sort: "price", dir: "asc" }
  },
  {
    key:    "Preis2",
    text:   translate( "Preis absteigend" ),
    value:  "price",
    params: { sort: "price", dir: "desc" }
  },
  // {
  //   key:    "Sale",
  //   text:   translate( "extras:salerabatt" ),
  //   value:  "extra:salerabatt",
  //   params: { sort: "extras:salerabatt", dir: "desc" }
  // }
]

const pageCountOptions = [
  {
    key:   "12",
    text:  "12",
    value: "12"
  },
  {
    key:   "24",
    text:  "24",
    value: "24"
  },
  {
    key:   "32",
    text:  "32",
    value: "32"
  },
  {
    key:   "64",
    text:  "64",
    value: "64"
  }
]


export default class Filter extends Component {

  componentDidMount() {

  }

  handlePageSelect = ( page ) => {
    this.props.onChange( { page } )
  }

  render() {

    const { hidePagination, hidePageSize, hideDirections, onlyPagination, dir, sort, count } = this.props

    if ( onlyPagination ) {
      return <div className="cb overflow-hidden pb3 tc">
        <Pagination filter={this.props}
                    onChange={this.handlePageSelect}/>
      </div>
    }

    return <div>
      <Form>
        <div className="flex justify-between">
          <div className="">
            {!hidePagination && <Pagination filter={this.props}
                                            onChange={this.handlePageSelect}/>}
          </div>


          <div className="flex justify-end">
            <div className="pr2" style={{ width: "80px" }}>
              {!hidePageSize && <div>
                <div className={"black-60 pb1"}><label htmlFor="">{translate("Artikel pro Seite")}</label></div>
                <Dropdown
                  fluid
                  value={count}
                  selection
                  options={pageCountOptions}
                  onChange={( e, { value } ) => {
                    console.log( { pageSize: value } )
                    this.props.onChange( { pageSize: value } )
                  }}
                />

              </div>}
            </div>

            <div className={`${!hideDirections ? "pr2" : "pr1"}`}>
              <div className={"black-60 pb1"}><label htmlFor="">{translate( "Sortierung" )}</label></div>
              <Dropdown
                value={sort}
                selection
                options={sortOptions}
                onChange={( e, { value } ) => {
                  let item = sortOptions.find( item => item.value === value )
                  if ( item ) {
                    this.props.onChange( item.params )
                  }
                }}
              />
            </div>

            {!hideDirections && <div>
              <div className={"black-60 pb1"}><label htmlFor="">&nbsp;</label></div>
              <Button.Group basic size="small">
                <Button active={dir === "desc"} onClick={() => {
                  this.props.onChange( { dir: "desc" } )
                }} icon={"chevron down"}/>
                <Button active={dir === "asc"} onClick={() => {
                  this.props.onChange( { dir: "asc" } )
                }} icon={"chevron up"}/>
              </Button.Group>
            </div>
            }
          </div>

        </div>
      </Form>
    </div>
  }
}





// WEBPACK FOOTER //
// ./src/theme/hobbyfun/components/Filter/Filter.js